import React, { useState } from "react";
import { filterLanded, filterWindow } from "../lib/columnFilter";
import { byUrgencyThenSize } from "../lib/queueOrder";
import { revisedConfirmations } from "../lib/revisions";
import { jobsByStatus } from "../lib/selectors";
import { useMcOps } from "../lib/McOpsContext";
import { ColumnFilter, KanbanColumn, StatCard } from "../components/Common";
import { BoardTitleRow } from "../components/JobSearch";

export const LocalMovesPage = () => {
  const { state } = useMcOps();
  // Confirmed and Intro Completed show the current week by default: that is
  // what the coordinators review in their weekly meeting.
  const [filters, setFilters] = useState({
    daily: "all",
    revised: "today",
    ready: "all",
    confirmed: "week",
    intro: "week",
  });
  const filterFor = (column) => (
    <ColumnFilter
      value={filters[column]}
      onChange={(key) => setFilters((prev) => ({ ...prev, [column]: key }))}
    />
  );

  // New jobs within 2 weeks come first; far-out weekly assignments (waiting
  // for their introduction call) follow, each group soonest-and-largest first.
  const dailyAssign = byUrgencyThenSize(
    filterLanded(jobsByStatus(state, "daily-assign"), filters.daily),
  ).concat(
    byUrgencyThenSize(filterLanded(jobsByStatus(state, "weekly-assign"), filters.daily)),
  );
  const confirmedUpdate = revisedConfirmations(state, filterWindow(filters.revised));
  const readyToConfirm = filterLanded(
    jobsByStatus(state, "ready-to-confirm"),
    filters.ready,
  );
  const confirmed = filterLanded(
    jobsByStatus(state, "confirmed"),
    filters.confirmed,
    undefined,
    (j) => j.confirmedAt || j.landedAt,
  );
  const introDone = filterLanded(
    jobsByStatus(state, "intro-done"),
    filters.intro,
    undefined,
    (j) => j.introDoneAt || j.landedAt,
  );

  return (
    <div className="page active">
      <BoardTitleRow title="Local Moves" />

      <div className="counter-row cols-5">
        <StatCard icon="clipboard" color="blue" num={dailyAssign.length} label="New Jobs" />
        <StatCard icon="check" color="green" num={confirmedUpdate.length} label="Revision Confirmation" />
        <StatCard icon="reply" color="red" num={readyToConfirm.length} label="Ready to Confirm" />
        <StatCard icon="activity" color="amber" num={confirmed.length} label="Confirmed This Week" />
        <StatCard icon="reply" color="purple" num={introDone.length} label="Intro Completed This Week" />
      </div>

      <div className="kanban cols-5">
        <KanbanColumn
          title="New Daily Assignments"
          jobs={dailyAssign}
          color="var(--primary)"
          screenNo={1}
          hideCount
          showPriority
          toolbar={filterFor("daily")}
        />
        <KanbanColumn
          title="Revised Confirmations"
          jobs={confirmedUpdate}
          color="var(--success)"
          screenNo={2}
          hideCount
          showRevisions
          emptyLabel="No confirmed jobs changed"
          toolbar={filterFor("revised")}
        />
        <KanbanColumn
          title="Ready to Confirm"
          jobs={readyToConfirm}
          color="var(--danger)"
          tab="s3"
          screenNo={3}
          hideCount
          toolbar={filterFor("ready")}
        />
        <KanbanColumn
          title="Confirmed This Week"
          jobs={confirmed}
          color="var(--cyan)"
          screenNo={4}
          hideCount
          emptyLabel="No jobs confirmed this week"
          toolbar={filterFor("confirmed")}
        />
        <KanbanColumn
          title="Intro Call Completed This Week"
          jobs={introDone}
          color="var(--indigo)"
          screenNo={5}
          hideCount
          toolbar={filterFor("intro")}
        />
      </div>
    </div>
  );
};
